import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ITableCellItem} from "../../table-cell";
import {ITableColumn} from "../../table-column";
import {ITableDataItem} from "../../table-data-item";
import {extractSubObjectValue} from "../../table.helpers";

@Component({
  selector: 'app-simple-table-cell',
  templateUrl: './simple-table-cell.component.html',
  styleUrl: './simple-table-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimpleTableCellComponent implements  ITableCellItem{
    private _calculatedCellValue:string ='';
    private _dataItem: ITableDataItem;
    public _columnOptions: ITableColumn;

 
    @Input() set dataItem(dataItem: ITableDataItem) {
        this._dataItem=dataItem;
        this.calculateData();
    }


    @Input() set columnOptions(columnOptions: ITableColumn){
        this._columnOptions = columnOptions;
        this.calculateData();
    }

    get columnOptions(){
        return this._columnOptions;
    }


    get calculatedCellValue(){
        return this._calculatedCellValue;
    }

    private calculateData(){
        if(this._columnOptions){
            this._calculatedCellValue = extractSubObjectValue(this._dataItem,this._columnOptions);
        }
    }
}
